import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";

const CreateTemplateComponent = loadable(
  () => import("../../components/Template/CreateTemplate")
);
const CreateTemplate = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["delivery-charge-template"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE_TEMPLATE}`;
    let formData = {
      ...values,
      is_branch: values?.type === "Branch" ? true : false,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">
          Create Rate Template
        </span>
      </div>
      <CreateTemplateComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateTemplate;
